import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import { RESTAURANT_ADDRESS, WHATSAPP_LINK } from "@/mocks/restaurant";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-50 pb-32 pt-14 md:pb-36 md:pt-20">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-10">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div>
            <Logo />
            <p className="mt-5 max-w-xs font-body text-sm leading-relaxed text-secondary-500">
              {RESTAURANT_ADDRESS}
            </p>
          </div>

          <div className="font-body text-sm leading-relaxed text-secondary-500">
            <p>{t("footer.schedule")}</p>
            <p className="mt-2">{t("footer.sunday")}</p>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center gap-2 text-primary-500 transition-colors hover:text-primary-600 cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-lg" aria-hidden="true" />
              +57 302 6095958
            </a>
          </div>
        </div>

        <div className="mt-10 border-t border-background-300/60 pt-6">
          <p className="font-body text-xs leading-relaxed text-secondary-500/80">
            {t("footer.legal")}
          </p>
          <p className="mt-4 font-body text-xs text-secondary-500/80">
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
}